export const calculateExtraPrice = (product, nrOfTravellers) => {
    let totalPrice = 0;
    let isUnitPrice = false;
    let displayPrice = 0;

    for (let price of product.ProductPeriod.PriceList) {
        if (price.PriceTypeEnum === 1 && price.TaxRateId === 5) {
            if (price.Amount !== 0) {
                totalPrice += price.Amount * nrOfTravellers;
            } else {
                isUnitPrice = true;
            }
        } else if (price.PriceTypeEnum === 7 && price.TaxRateId === 5) {
            if (price.Amount !== 0) {
                totalPrice += price.Amount;
                isUnitPrice = true;
            }
        }
    }

    if (isUnitPrice) {
        displayPrice = totalPrice;
    } else {
        displayPrice = totalPrice / nrOfTravellers;
    }

    return {
        totalPrice,
        isUnitPrice,
        displayPrice,
    }
};
